module.exports = __webpack_public_path__ + "img/model-iphone-v4.04bc4db1.png";